import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import { IInsightsWorkspaceOption } from "v2/services/insights.service";
import { ContractSelector } from "./ContractSelector";
import { INSIGHTS_BORDER, INSIGHTS_FAINT, INSIGHTS_FONT } from "./tokens";

export interface ContractBarProps {
  workspaces: IInsightsWorkspaceOption[];
  workspaceId: string;
  onWorkspaceChange: (workspaceId: string) => void;
  disabled?: boolean;
  /** Ver `ContractSelector` — só o assistente consulta contratos em conjunto. */
  allowAll?: boolean;
  /** Conteúdo alinhado à direita, se a aba tiver algo a dizer ali. */
  children?: ReactNode;
}

/**
 * A faixa que diz de qual contrato sai o que está abaixo dela.
 *
 * A mesma nas duas abas por escolha: o workspace é compartilhado entre chat e
 * relatórios (trocar de aba não troca o escopo debaixo do usuário), então ter
 * dois controles com aparências diferentes para o mesmo estado era o que fazia
 * o painel parecer duas telas coladas.
 */
export function ContractBar({
  workspaces,
  workspaceId,
  onWorkspaceChange,
  disabled,
  allowAll,
  children,
}: ContractBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
        px: { xs: 2, md: 4 },
        py: 1.25,
        borderBottom: `1px solid ${INSIGHTS_BORDER}`,
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
        <Typography
          component="span"
          sx={{
            flexShrink: 0,
            fontFamily: INSIGHTS_FONT,
            fontWeight: 700,
            fontSize: 11,
            letterSpacing: 0.4,
            textTransform: "uppercase",
            color: INSIGHTS_FAINT,
          }}
        >
          Contrato
        </Typography>
        <ContractSelector
          workspaces={workspaces}
          value={workspaceId}
          onChange={onWorkspaceChange}
          disabled={disabled}
          allowAll={allowAll}
        />
      </Box>
      {children}
    </Box>
  );
}
